import React, { FC } from 'react'

import Arrow from 'Icons/arrow-right-circle.svg'
import { Customer } from 'Types'

import CustomerFieldsGroup from 'Components/CustomerFieldsGroup'

interface Props {
  currentCustomer: Customer | null
  onLoginComplete(): void
}

const LoginForm: FC<Props> = ({ currentCustomer, onLoginComplete }) => (
  <div className="user-profile-page__login">
    <CustomerFieldsGroup
      customer={currentCustomer}
      renderSubmitButton={(submit, loading, isPhoneStep) =>
        currentCustomer?.signedUp || isPhoneStep ? null : (
          <div className="d-flex / justify-content-end / mt-4">
            <div className="checkout-step__next-step-button-wrapper">
              <button
                className="checkout-step__next-step-button / btn btn-accent / d-flex align-items-center justify-content-center"
                disabled={loading}
                type="button"
                onClick={submit}
              >
                <span>Continue</span>
                <Arrow className="sociavore-icon sociavore-icon--fill / ml-auto" />
              </button>
            </div>
          </div>
        )
      }
      onComplete={onLoginComplete}
    />
  </div>
)

export default LoginForm
